<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     

      <div class="order-shipping-menulists" v-loading="loading">
        <!-- 暂无快递信息 -->
        <div v-if="shippinglists.length==0" style="display:flex;width:100%;height:200px;background:rgb(221, 221, 221,.3);justify-content:center;align-items:center;color:#666666;font-size:14px;font-weight:500">
            <img src="../../../assets/packet.png" style="float:left;width:40px;height:40px"/>
            <span style="float:left;font-size:13px;margin-left:10px;font-weight:500;">暂无快递信息</span>
        </div>

        <div :class="showindex==index ? 'order-shipping-menutitles order-shipping-menutitles-on' : 'order-shipping-menutitles'" 
             v-for="(item,index) in shippinglists"
             @click="changeshipping(index)">
           <div class="order-shipping-menu-name">{{item.name}}（{{item.documents}}）</div>
           <a class="order-shipping-menu-goods-look" @click="lookshippinggoods(item)">
              <img src="@/assets/shipping_gray.png">
           </a>
        </div>
      </div>

      <div v-loading="loading" style="display:inline-block;width:100%;">
          <!-- 暂无快递信息 -->
          <div v-if="shippinglists.length > 0 && travels.length==0" style="display:flex;width:100%;height:200px;justify-content:center;align-items:center;color:#666666;font-size:14px;font-weight:500">
              <img src="../../../assets/shipping.png" style="float:left;width:40px;height:40px"/>
              <span style="float:left;margin-left:1%">暂无物流信息</span>
          </div>

          <div class="order-shipping-travels" v-for="(item,index) in travels" :style="index==0 ? 'color:#67C23A;border-left:2px solid #67C23A' : '' ">
            <i :style="index==0 ? 'background:#67C23A;width:20px;height:20px;margin:0 0 0 -10.5px' : ''">
              <img src="@/assets/right_select_full.png" v-if="index==0" style="width:20px;height:20px" />
            </i>
            <div class='order-shipping-travels-content'>{{item.content}}</div>
            <div class='order-shipping-travels-time'>{{item.msgTime}}</div>
          </div>
      </div>


      <el-dialog title="查看快递商品" :visible.sync="shippingDialog" top="25vh" width="40%" :modal-append-to-body='false'>
          <el-table :data="shippinggoodslists" v-loading="showgoodsloading">
            <el-table-column label="商品">
              <template slot-scope="scope">
                <div style="float:left;width:60px;height:60px;display:flex;border-radius:6px;background:#dddddd;justify-content:center;align-items:center">
                  <i style="padding:.1rem .4rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.from==2">JD</i>
                  <img :src="scope.row.thumb" style="border-radius:6px;max-width:85%;max-height:85%"/>
                </div>
                <div style="float:left;width:73%;margin-left:2%">
                  <span style="float:left;width:87%;margin-left:2%;font-size:13px;line-height:23px;color:#666666">{{scope.row.goodsname}}</span><br/>
                  <span style="float:left;margin-left:2%;color:#909399;font-size:13px;line-height:23px;color:#999999">规格：{{scope.row.propertyname}}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
      </el-dialog>
        
  </div>
  </transition> 
</template>

<script>
export default {
  props: ["value","ordertype"],
  data () {
    return {
      url:this.GLOBAL.domain+"Sellshippingbirld/index",
      transitionshow:true,
      orderid:'',
      shippinglists:[],
      travels:[],
      loading:false,
      showindex:'',

      showgoodsloading:false,
      shippinggoodslists:[],
      shippingDialog:false,

    }  
  },

  watch: {

    //获取当前订单快递信息
    value(val) {
      if (val) {
          this.orderid=val;
          this.getmyshippings();
      }
    },

  },

  mounted(){
     //获取当前订单快递信息
     this.orderid=this.value;
     this.getmyshippings();
  },

  methods:{

    //查看快递商品
    lookshippinggoods(item) {
        this.shippingDialog=true;
        this.showgoodsloading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'showshippinggoods',token:this.$cookies.get('token'),orderid:this.orderid,shippingid:item.shippingid,type:item.type}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.showgoodsloading=false;
            }else{
                this.shippinggoodslists=[];
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.shippinggoodslists=result;
                this.showgoodsloading=false;
            }
        }).catch((res) => {
            this.showgoodsloading=false;
        });
    },


    //切换查看物流信息
    changeshipping(index) {
       this.travels=this.shippinglists[index].lists;
       this.showindex=index;
    },

    
    //获取订单物流信息
    getmyshippings() {
        this.shippinglists=[];
        this.travels=[];
        this.loading=true;
        
        var resource = this.$resource(this.url);
        resource.save({act:'getordershippinglists',token:this.$cookies.get('token'),orderid:this.orderid,type:this.ordertype}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.loading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                this.shippinglists=result;

                this.travels=[];
                this.travels=this.shippinglists[0].lists.length > 0 ? this.shippinglists[0].lists : [];
                this.showindex=0;
                this.loading=false;
            }
        }).catch((res) => {
            this.loading=false;
        });

    },           

  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.order-shipping-menulists {display:inline-block;width:100%;font-size:13px;font-weight:500;color:#666666;margin-bottom:50px}
.order-shipping-menutitles {display:inline-block;padding:10px 20px;transition:.3s all;cursor:pointer;border-bottom:2px solid #fff;justify-content:center;align-items:center}
.order-shipping-menu-goods-look {float:left;display:inline-block;width:20px;height:20px;margin-top:3px;justify-content:center;align-items:center;border-radius:50%;}
.order-shipping-menu-goods-look img {max-width:100%;max-height:100%}
.order-shipping-menutitles-on {border-bottom:2px solid #e6a23c;}
.order-shipping-menu-name {display:inline-block;float:left;}
.order-shipping-travels {float:left;margin-left:2%;width:94%;font-size:12px;padding:0 0 15px 3%;border-left:2px solid #dddddd;position:relative}
.order-shipping-travels i {font-style:normal;width:15px;height:15px;border-radius:50%;background:#dddddd;position:absolute;left:0;top:0;margin:0 0 0 -8.5px}
.order-shipping-travels-content {float:left;width:97%;line-height:23px}
.order-shipping-travels-time {float:left;width:97%;line-height:23px}
</style>


// WEBPACK FOOTER //
// src/components/mall/shipping/showshipping.vue